import React, { useEffect } from 'react';
// import Loading from '../../assets/loading.png';
import Loading from '../../assets/Staples.gif';
// import modelObject from '../../assets/poc_one.glb';
// import modelObjectIos from '../../assets/poc_one.usdz'

import modelObject from '../../assets/poc_two.glb';
import modelObjectIos from '../../assets/poc_two.usdz'

// import modelObject from '../../assets/poc_three.glb';
// import modelObjectIos from '../../assets/poc_three.usdz'

const Shoes = ({ isOpen }) => {

    useEffect(() => {
        const modelViewerTexture = document.querySelector("model-viewer");

        modelViewerTexture.addEventListener('preload', callLoad)
        // modelViewerTexture.addEventListener('click', callClick)

        


        // modelViewerTexture.addEventListener("scene-graph-ready", (ev) => {

        //     let material = modelViewerTexture.model.materials[0];

        //     document.querySelector('#diffuse').addEventListener('input', (event) => {
        //         material.pbrMetallicRoughness.baseColorTexture.texture.source.setURI(event.target.value);
        //     });

        //     document.querySelector("#controls").addEventListener('beforexrselect', (ev) => {
        //         ev.preventDefault();
        //     });
        // })

        return () => {
            modelViewerTexture.removeEventListener('preload', callLoad)
           // modelViewerTexture.removeEventListener('click', callClick)
        };



    }, [])

    const callLoad = () => {
    

        let currentURL = window.location.search;
        currentURL = currentURL.substr(1, currentURL.length);
        const urlParams = currentURL.split("&");
        if (urlParams[0] !== '') {
            const modelViewerTexture = document.querySelector("model-viewer");
            modelViewerTexture.activateAR();
        }
    }

    // const callClick = () => {
    //     debugger;
    //     const modelViewerTexture = document.querySelector("model-viewer");
    //     console.log(modelViewerTexture.availableAnimations, 'annimation name');
    //     if (modelViewerTexture.availableAnimations.length)
    //         if (modelViewerTexture.paused) {
    //             modelViewerTexture.play()
    //         } else {
    //             modelViewerTexture.pause()
    //             modelViewerTexture.currentTime = 0;
    //         }

    //     console.log('click was called');

    // }

    return (
        <model-viewer camera-controls src={modelObject}
            alt="A 3D model of a Drawer" ar camera-orbit="33deg 67deg auto"
            // ar-modes="webxr scene-viewer quick-look"
            // autoplay
            // animation-name="Running"
            ar-modes="webxr scene-viewer quick-look"
            loading='eager'
            poster={Loading}
            ios-src={modelObjectIos} shadow-intensity="1">
            <button slot="ar-button" className="ar-button" id="ar-button">View in your space</button>
            <div id="ar-prompt">
                <img src="https://cdn.khronos.org/assets/blog/live-gltf-asset-editing-in-your-browsereven-in-ar/hand.png" />
            </div>
            <div id="controls">
            </div>
        </model-viewer>
    )

}

export default Shoes